<template>
  <div>
    <vxe-grid
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="height"
      size="mini"
      resizable
      border
      ref="contrinerTable"
      :edit-config="{
        trigger: 'click',
        mode: 'cell',
        activeMethod: activeCellMethod,
      }"
      :mouse-config="{ selected: true }"
      :checkbox-config="{
        highlight: true,
        reserve: true,
      }"
      :edit-rules="validRules"
      @edit-closed="editClosed"
      @edit-actived="editActived"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_del') || '删除'"
            placement="top"
            v-if="!disabled"
          >
            <i class="el-icon-delete tool-btn" @click="del(row)"></i>
          </el-tooltip>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
export default {
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    isNStatus: { type: Boolean, default: false },
    shipmentBookingCode: { type: String, default: '' },
    shipmentCode: { type: String, default: '' },
    height: { type: Number, default: 0 },
  },
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
      },
      tableColumns: [
        {
          type: 'seq',
          field: 'seq',
          width: 50,
          align: 'center',
          fixed: 'left',
        },
        {
          field: 'checkbox',
          width: 40,
          align: 'center',
          fixed: 'left',
          type: 'checkbox',
          visible: this.isNStatus,
        },
        {
          title: this.$l('INDEX.table_label_operation') || '操作',
          field: 'col-opt',
          width: 55,
          headerAlign: 'center',
          align: 'center',
          visible: this.isNStatus,
          slots: {
            default: 'opt',
          },
        },
        {
          title: this.$l('INDEX.form_label_editContainerNo') || '编辑柜号',
          field: 'editContainerNo',
          minWidth: 100,
          headerAlign: 'center',
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title: this.$l('INDEX.form_label_containerContractNo') || '外运子单号',
          field: 'containerContractNo',
          width: 120,
          headerAlign: 'center',
          align: 'center',
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title: this.$l('INDEX.form_label_containerNo') || '集装箱号',
          field: 'containerNo',
          minWidth: 150,
          headerAlign: 'center',
          showHeaderOverflow: true,
          showOverflow: true,
          visible: !this.isNStatus,
          editRender: {
            name: 'ElInput',
            props: {
              placeholder:
                this.$l('INDEX.form_placeholder_containerNo') ||
                '请输入集装箱号',
              clearable: true,
            },
          },
        },
        {
          title: this.$l('INDEX.form_label_sealNo') || '箱封号',
          field: 'sealNo',
          minWidth: 150,
          headerAlign: 'center',
          showHeaderOverflow: true,
          showOverflow: true,
          visible: !this.isNStatus,
          editRender: {
            name: 'ElInput',
            props: {
              placeholder:
                this.$l('INDEX.form_placeholder_sealNo') || '请输入箱封号',
              clearable: true,
            },
          },
        },
        {
          title: this.$l('INDEX.form_containerWeight') || '集装箱皮重(KG)',
          field: 'containerWeight',
          minWidth: 150,
          headerAlign: 'center',
          showHeaderOverflow: true,
          showOverflow: true,
          visible: !this.isNStatus,
          editRender: {
            name: 'ElInputNumber',
            props: {
              placeholder:
                this.$l('INDEX.form_placeholder_containerWeight') ||
                '请输入集装箱皮重',
              clearable: true,
              controlsPosition: 'right',
              style: 'width:100%',
              min: 0,
              step: 0.01,
              precision: 4,
            },
          },
        },
      ],
      validRules: {
        // containerNo: [
        //   {
        //     required: true,
        //     message:
        //       this.$l('INDEX.form_placeholder_containerNo') || '请输入集装箱号',
        //   },
        // ],
        // sealNo: [
        //   {
        //     required: true,
        //     message: this.$l('INDEX.form_placeholder_sealNo') || '请输入箱封号',
        //   },
        // ],
        // containerWeight: [
        //   {
        //     required: true,
        //     message:
        //       this.$l('INDEX.form_placeholder_containerWeight') ||
        //       '请输入集装箱皮重',
        //   },
        // ],
      },
      data: {},
    }
  },
  methods: {
    getTableData() {
      const { fullData } = this.$refs.contrinerTable.getTableData() || {}
      return fullData
    },
    async validate() {
      const result = await this.$refs.contrinerTable.validate(true)
      return !result
    },

    del(row) {
      this.delData([row.shipmentContainerCode])
    },
    removeCheckboxRow() {
      const data = this.$refs.contrinerTable
        .getCheckboxRecords()
        .map((t) => t.shipmentContainerCode)
      if (!data || !data.length) {
        this.$message({
          showClose: true,
          message:
            this.$l('INDEX.tips_question_del_rows') || '请选择需要删除的数据！',
          type: 'warning',
        })
        return
      }
      this.delData(data)
    },
    delData(containerCodeList) {
      this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => {
        this.$api
          .shipmentBookingContainerDelApi({
            containerCodeList,
            shipmentCode: this.shipmentCode,
            shipmentBookingCode: this.shipmentBookingCode,
          })
          .then(() => {
            this.$message({
              showClose: true,
              message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
              type: 'success',
            })
            this.$emit('reload')
          })
      })
    },
    activeCellMethod() {
      return !this.disabled
    },
    editActived({ row }) {
      this.data = {}
      this.data = { ...row }
    },
    //编辑完成后保存
    editClosed({ row }) {
      if (
        row.containerNo == this.data.containerNo &&
        row.sealNo == this.data.sealNo &&
        row.containerWeight == this.data.containerWeight
      ) {
        return
      }
      this.$api
        .shipmentBookingContainerEditApi({
          shipmentCode: this.shipmentCode,
          shipmentBookingCode: this.shipmentBookingCode,
          ...row,
        })
        .then((res) => {
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_save_ok') || res.msg,
            type: 'success',
          })
          this.$emit('reload')
        })
        .catch(() => {})
    },
  },
}
</script>
